import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

const SelectController = ({ label, value, onChange, options, setFirst, hasError }) => {
return(
  <Autocomplete
    options={options}
    getOptionLabel={(option) => option.label}
    value={options.find((opt) => opt.value === value) || null}
    onChange={(event, selectedValue) => onChange(selectedValue ? selectedValue.value : '')}
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        margin="normal"
        error={hasError }
        helperText={hasError ? 'El tipo es requerido.' : ''}
        variant="standard"
        fullWidth
        onBlur={() =>  setFirst(false)}
      />
    )}
  />
);
}

export default SelectController;
